<template>
  <v-card tile>
    <v-card-title>
      <v-img
        max-height=100
        contain
        src="../assets/jwt.png"
      />
    </v-card-title>
    <v-card-text>

      <p>
        Normally a front-end application does not use a client-secret. The client-secret is recoverable from the front-end code which obviously defeats
        the purpose of a secret. Amazon <strong>Cognito</strong> allows you to define App clients with only an identifier but we included a secret in this
        client-app for demo-purpose.
      </p>

      <v-flex xs12>
        <v-text-field
          label="Provide client identification"
          :readonly="loading"
          v-model="clientid"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          label="Provide client secret key"
          :readonly="loading"
          v-model="clientsecret"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          label="Cognito"
          disabled
          v-model="url"
          persistent-hint
          hint="Endpoint for authentication"
        ></v-text-field>
      </v-flex>
      <br>
      <v-flex xs12>
        <v-btn
          :loading="loading"
          block
          :disabled="!clientid || !clientsecret"
          @click="submit"
        >
          REQUEST JSON WEB TOKEN
        </v-btn>
      </v-flex>
      <v-flex xs12>
        <v-textarea
          persistent-hint
          hint="JSON Web Token returned by authentication endpoint"
          readonly
          v-model="token"
          rows="10"
        />
      </v-flex>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex"
import store from "@/store"

export default {
  data: () => ({
    url: 'https://ab-ovo.auth.eu-central-1.amazoncognito.com/oauth2/token',
    loading: false,
    clientid: '7remoa55olm5jijg5p7eop46j',
    clientsecret: ''
  }),
  computed: {
    ...mapGetters("token", ["token"])
  },
  methods: {
    async submit () {
      this.loading = true
      await store.dispatch("token/getToken", {
        url: this.url,
        clientid: this.clientid,
        clientsecret: this.clientsecret
      })
      this.loading = false
    }
  }
};
</script>
